import { render, staticRenderFns } from "./TemplateGalleryUnlayerCard.vue?vue&type=template&id=1d7b8cae&scoped=true"
import script from "./TemplateGalleryUnlayerCard.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryUnlayerCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryUnlayerCard.vue?vue&type=style&index=0&id=1d7b8cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b8cae",
  null
  
)

export default component.exports